import type { KeyboardEvent } from 'react';

/**
 * Space already activates a checkbox, radio or switch. Enter would submit the
 * nearest form instead — so we treat it as a click, the same way a button does.
 */
export function activateOnEnter(event: KeyboardEvent<HTMLInputElement>) {
  if (event.key !== 'Enter') {
    return;
  }
  event.preventDefault();
  event.currentTarget.click();
}
